module.exports = __webpack_public_path__ + "static/media/marron.73c8fb1e.png";